export const markAllAsRead = "Wab";
export const markAsReadNumberOfConversationsWhenCountIsNegative = "Xab";
export const markAsReadNumberOfItemsWhenCountIsNegative = "Yab";
export const markAsReadNumberOfConversations = "Zab";
export const markAsReadNumberOfItems = "_ab";
export default {markAllAsRead,markAsReadNumberOfConversationsWhenCountIsNegative,markAsReadNumberOfItemsWhenCountIsNegative,markAsReadNumberOfConversations,markAsReadNumberOfItems};